// extracted by mini-css-extract-plugin
module.exports = {"root":"bw_b9"};